export default "__VITE_ASSET__kTYG5E9U__"